
import React, { useState, useEffect } from 'react';
import associaImmagineENomeANomeUtente from '../../../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente';
import umanizzaDataSenzaOre from '../../../interfaccia/funzioniComuni/umanizzaDataSenzaOre';

function NotaTooltip({
    nomeUtente,
    utente,
    dataNota,
    contenuto
}) {

    const { pathImmagine, nomeDisplay } = associaImmagineENomeANomeUtente(nomeUtente, utente.username)

    return (

        <div className='pa2 tooltip'>
            <img
                src={pathImmagine}
                className="br-100 w2 dib "
                alt="foto utente"></img>
                <div class="tooltiptext">
                    <span className='b'>{nomeDisplay}</span><br />
                    <span className='f6'>{umanizzaDataSenzaOre(dataNota)}</span><br />
                    <span className='f6 mt2'>{contenuto}</span>
                    
                </div>
        </div>

    )
}



export default NotaTooltip;



